import { renderSlot as _renderSlot, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, normalizeStyle as _normalizeStyle, withCtx as _withCtx, createVNode as _createVNode, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-1ff3f584"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "tabs-container" }
const _hoisted_2 = { class: "tabs-action-container" }
const _hoisted_3 = { class: "TableWithTabs-view-container" }
const _hoisted_4 = { class: "tabs-form-container" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_vue_drag_resize = _resolveComponent("vue-drag-resize")!
  const _component_a_spin = _resolveComponent("a-spin")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _renderSlot(_ctx.$slots, "action", {}, undefined, true)
    ]),
    _createElementVNode("div", _hoisted_3, [
      (_ctx.tableWidth)
        ? (_openBlock(), _createBlock(_component_vue_drag_resize, {
            key: 0,
            isActive: true,
            preventActiveBehavior: true,
            isDraggable: false,
            isResizable: _ctx.resizeActive,
            sticks: ['bm'],
            h: _ctx.tableHeight,
            w: _ctx.tableWidth,
            x: 0,
            y: 0,
            z: 10,
            onResizing: _ctx.onResizing,
            onResizestop: _ctx.onResizstop
          }, null, 8, ["isResizable", "h", "w", "onResizing", "onResizestop"]))
        : _createCommentVNode("", true),
      _createElementVNode("div", {
        class: "tabs-table-container",
        style: _normalizeStyle({ height: _ctx.tableHeight + 'px' })
      }, [
        _renderSlot(_ctx.$slots, "tableWidget", {}, undefined, true)
      ], 4),
      _createVNode(_component_a_spin, { spinning: _ctx.loading }, {
        default: _withCtx(() => [
          _createElementVNode("div", _hoisted_4, [
            _renderSlot(_ctx.$slots, "expandForm", {}, undefined, true)
          ])
        ]),
        _: 3
      }, 8, ["spinning"])
    ])
  ]))
}